/* eslint-disable no-console */
import { Injectable } from "../../dependencies/injectable";
import { LOG_SERVICE, LogService } from "../log.service";

/**
 * Log service using native console
 */
@Injectable(LOG_SERVICE)
export class NativeConsoleLogService implements LogService {

    debug = console.debug;
    info = console.info;
    warn = console.warn;
    error = console.error;

}
